import { ClipLoader } from "react-spinners";
import PropTypes from "prop-types";

const Loader = ({ loading }) => {
  return (
    loading && (
      <div className="loader-container">
        <ClipLoader color="#ffffff" size={35} />
      </div>
    )
  );
};

Loader.propTypes = {
    loading: PropTypes.bool.isRequired, 
  };

export default Loader;
